import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectCheckInTable(state),
        type: 'check-in',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryCheckIn,
    changeFilter: action.changeFilterCheckIn,
    toggleSort: action.toggleSortCheckIn,
    toggleMultiSort: action.toggleMultiSortCheckIn,
    gotoPage: action.gotoPageCheckIn,
    initialColumnsVisibility: action.initialTableSettingsCheckIn,
    toggleColumnVisibility: action.toggleColumnVisibilityCheckIn,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/CheckInSalesOrderSearchContainer.js